
declare const gtag: Function
import Vue from "vue";

import constantsStore from "@/state/modules/constants";
import optionsStore from "@/state/modules/options";
import partnersStore from "@/state/modules/partners";

export default Vue.extend({
	name: "add-partner-page",
	page: {
		title: "Partner Information",
		meta: [
			{
				name: "description",
				content: "Page to enter a new partner or edit an existing partner",
			},
		],
	},
	beforeRouteEnter (to, {}, next) {
		var id: string;
		if (to.query.id) {
			id = to.query.id.toString();
		} else {
			id = constantsStore.state.defaultPartnerId;
		}
		if (!partnersStore.state[id]) {
			partnersStore.dispatchGetPartner(id)
				.then(() => {
					next(vm => (vm as any).setData());
				})
				.catch(() => {
					if (id === constantsStore.state.defaultPartnerId) {
						// No Default yet.
						partnersStore.state[id] = {
							id: id,
							team: "nis",
							settings: {}
						}
						next(vm => (vm as any).setData());
					} else {
						next("404");
					}
				});
		} else {
			next(vm => (vm as any).setData());
		}
	},
	props: {
		theme: String,
	},
	data(): {partner: {[key: string]: any}} {
		return {
			partner: {
				id: ""
			}
		}
	},
	computed: {
		id(): string {
			if (this.$route.query.id) {
				return this.$route.query.id.toString();
			} else {
				return "";
			}
		},
		getUniqueName(): string {
			if (this.partner.id) {
				return this.partner.id;
			} else if (this.partner.name) {
				var id: string = this.partner.name.replace("&", "And").replace(/[^\w-_]/g, "");
				if (this.partner.officeId && constantsStore.state.rsiOfficeIds.indexOf(this.partner.officeId.value) >= 0) {
					id = constantsStore.state.rsiPrefix + id;
				}
				if (this.partner.officeId && constantsStore.state.dsiOfficeIds.indexOf(this.partner.officeId.value) >= 0) {
					id = constantsStore.state.dsiPrefix + id;
				}
				return id;
			}
			return "";
		},
		partnerTypeOptions(): ISelectOption[] {
			return optionsStore.state.partnerType;
		},
		officeIdOptions(): ISelectOption[] {
			return optionsStore.state.officeId;
		},
		employeeIdOptions(): ISelectOption[] {
			return optionsStore.state.employeeId;
		},
		questionsPhoneNumberOptions(): ISelectOption[] {
			return optionsStore.state.questionsPhoneNumber;
		},
	},
	methods: {
		idOrDefault() {
			if (this.id) {
				return this.id;
			}
			return constantsStore.state.defaultPartnerId;
		},
		setData() {
			var partnerInfo = partnersStore.state[this.idOrDefault()];
			const selectOptionKeys = Object.keys(optionsStore.state);
			var to: any = {
				id: "",
				team: "nis",
				settings: {}
			};
			this.partner = this.generateFormData(partnerInfo, to, selectOptionKeys);
			if (this.id !== constantsStore.state.defaultPartnerId && this.partner.id === constantsStore.state.defaultPartnerId) {
				this.partner.id = "";
				this.partner.name = "";
				this.partner.officeId = "";
				this.partner.employeeId = "";
				this.partner.settings.uniqueId = "";
			}
		},
		generateFormData(from: any, to: any, selectOptionKeys: string[]): any {
			if (!from) {
				return to;
			}
			Object.keys(from).forEach((key) => {
				if (key === "settings") {
					to[key] = this.generateFormData(from[key], to[key], selectOptionKeys);
				} else if (selectOptionKeys.includes(key) && from[key]) {
					to[key] = optionsStore.state[key].find((option: ISelectOption) => option.value === from[key]);
					if (!to[key] && from[key]) {
						to[key] = { value: from[key], label: from[key] };
					}
				} else {
					to[key] = from[key];
				}
			});
			return to;
		},
		formToIPartner(): IPartner {
			const selectOptionKeys = Object.keys(optionsStore.state);
			var partnerInfo: IPartner = {
				id: "",
				team: "nis",
				settings: {}
			};
			const original = this.partner.id ? partnersStore.state[this.partner.id] : partnersStore.state[constantsStore.state.defaultPartnerId];

			// Convert form info into IPartner to send it to the server.
			Object.keys(this.partner).forEach((key) => {
				if (key === "settings") {
					// Handle dropdowns first
					if (typeof this.partner.settings.partnerType === "object") {
						this.partner.settings.partnerType = this.partner.settings.partnerType.value;
					}
					if (typeof this.partner.settings.questionsPhoneNumber === "object") {
						this.partner.settings.questionsPhoneNumber = this.partner.settings.questionsPhoneNumber.value;
					}
					partnerInfo[key] = this.partner[key];
				} else if (selectOptionKeys.includes(key) && typeof this.partner[key] === "object") {
					if (!this.partner.id || original[key] !== this.partner[key].value) {
						partnerInfo[key] = this.partner[key].value;
					}
				} else {
					if (!this.partner.id || original[key] !== this.partner[key]) {
						partnerInfo[key] = this.partner[key];
					}
				}
			});
			// Things that never change but are needed
			partnerInfo.id = this.partner.id;
			partnerInfo.team = "nis";

			// Handle RSI and DSI
			if (!partnerInfo.id) {
				var id: string = this.getUniqueName;
				if (id.startsWith(constantsStore.state.rsiPrefix) || id.startsWith(constantsStore.state.dsiPrefix)) {
					partnerInfo.id = id;
				}
			}

			return partnerInfo;
		},
		savePartner() {
			gtag('event', 'savePartner', { 'event_category': 'AddEditPartner', 'event_label': 'savePartner'});
			if (this.partner.id) {
				partnersStore.dispatchUpdatePartners(this.formToIPartner());
			} else {
				partnersStore.dispatchAddPartners(this.formToIPartner());
			}
			this.cancel();
		},
		deletePartner() {
			gtag('event', 'deletePartner', { 'event_category': 'AddEditPartner', 'event_label': 'deletePartner'});
			if (this.partner.id) {
				partnersStore.dispatchDeletePartners(this.partner.id);
			}
			this.cancel();
		},
		cancel() {
			this.$router.push("/partners");
		},
	},
});
